import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Grid } from 'seagull';
import { Typography } from 'seagull/components/Typography';
import { validateIntroMessage } from '~/business-logic/validators';
import IntroMessage from '~/components/AgreementStudioPage/AgreementStudioModal/IntroMessage/IntroMessage';
import { templateTypeToDropdownLabel, useEditIntroMessage } from '~/components/AgreementStudioPage/AgreementStudioModal/IntroMessage/IntroMessage.utils';
import { TemplateVariablesProvider } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariablesContext';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { PersistTemplateVariableValues } from '../PersistTemplateVariableValues';
const EMPTY_RICH_TEXT_FIELDS = [];
export const IntroductoryMessageModalContent = (param)=>{
    let { draft, setDraft, contact, worksAt } = param;
    const textFields = useMemo(()=>[
            draft.customNotificationText()
        ], [
        draft
    ]);
    return /*#__PURE__*/ _jsxs(TemplateVariablesProvider, {
        contact: contact,
        worksAt: worksAt,
        agreementName: draft.title(),
        effectiveDate: draft.effectiveDateAsDate(),
        initialTemplateVariableValues: draft.templateVariableValues(),
        textFields: textFields,
        richTextFields: EMPTY_RICH_TEXT_FIELDS,
        children: [
            /*#__PURE__*/ _jsx(PersistTemplateVariableValues, {
                setDraft: setDraft
            }),
            /*#__PURE__*/ _jsx(Grid, {
                rowGap: "small",
                children: /*#__PURE__*/ _jsx(IntroMessage, {
                    inputWidth: "380px",
                    initialTemplateContent: draft.customNotificationText(),
                    onMessageChange: (message)=>setDraft((prev)=>prev.setCustomNotificationText(message))
                })
            })
        ]
    });
};
export default function IntroductoryMessageCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip, contact, worksAt } = param;
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { getTemplateTypeByMessage } = useEditIntroMessage();
    const onClick = ()=>onOpenModal({
            shouldSubmit: async (editedDraft)=>{
                const error = validateIntroMessage(editedDraft.customNotificationText());
                return !error;
            },
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: draftCellsTexts.introductoryMessage(),
                    testId: 'edit-introductory-message-modal',
                    content: /*#__PURE__*/ _jsx(IntroductoryMessageModalContent, {
                        draft: draft,
                        setDraft: setDraft,
                        contact: contact,
                        worksAt: worksAt
                    }),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    }
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-introductory-message-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "introductory-message-".concat(index),
            children: templateTypeToDropdownLabel[getTemplateTypeByMessage(draft.customNotificationText())]
        })
    });
}
